module.exports = __webpack_public_path__ + "static/media/phone-stats.e621a347.svg";